<template>
  <div id="app">
    <RouterView />
    <SessionTimeoutPrompt />
  </div>
</template>

<style>
body {
  overflow: hidden;
}
</style>
 
 
